import React from "react";

import { doSignOut } from "../../services/firebase/auth";

function Closed() {

    function handleLogout(e) {
        doSignOut();
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', paddingLeft: 60, height: '100vh', textAlign: 'center' }}>
            <p><img src="/icons/lock.svg" width="30" /></p>
            <p>Access to your account has been limited. <br />Contact <a style={{ color: '#000' }} href="mailto:info@aurumstrength.com">info@aurumstrength.com</a> for more information.<br /><br /></p>
            <a  onClick={() => handleLogout()} style={{ color: '#bb0000', fontWeight: 600 }} href="#">Logout</a>
        </div>
    )
}

export default Closed;